import { faL } from "@fortawesome/free-solid-svg-icons";

const initialState = {
  data: {},
  accept: false,
  limit: 1,
  tag: false,
  text: false,
  validationText:false,
  validaton: {}
}


export const tempReducer = (state = initialState, action) => {


  switch (action.type) {

    case "SET_TEMPDATA": {
      return { ...state, data: action.data }
    }
    case "SET_ACCEPT": {

      return { ...state, accept: action.data }
    }
    case "SET_TEXT": {

      return { ...state, text: action.data }
    }
    case "SET_TAG": {

      return { ...state, tag: action.data }
    }
    case "SET_VALIDATION": {

      return { ...state, validaton: action.data }
    }
    case "SET_VALIDATION_TEXT": {

      return { ...state, validationText: action.data }
    }
    case "LOGOUT":
      return initialState;

    default:
      return state;

  }
};